'use client';

import DynamicPageComponents from '@/components/dynamic/DynamicPageComponents/DynamicPageComponents';
import { PageContent } from '@/components/organisms/PageContent/PageContent';
import { generateServiceStructuredData } from './Service.structuredData';
import { TLocale } from '@/types/global';
import { ModalVirtualTour } from '@/components/molecules/ModalVirtualTour/ModalVirtualTour';
import { usePageStore } from '@/store/usePageStore';
import { useEffect } from 'react';

export const Service = ({
  data,
  isPreview = false,
  slug,
  locale,
}: {
  data: any;
  isPreview?: boolean;
  slug?: string;
  locale: TLocale;
}) => {

  const stateSelector = usePageStore;
  const setCurrentSlugTranslations = stateSelector(
    (s) => s.setCurrentSlugTranslations
  );

  useEffect(() => {
    setCurrentSlugTranslations({
      en: data.config.slug.en,
      es: data.config.slug.es,
    });
  }, [setCurrentSlugTranslations, data.config.slug.en, data.config.slug.es]);

  const structuredData = isPreview
    ? generateServiceStructuredData({
        data,
        serviceSlug: slug || data.slug,
        locale,
      })
    : null;

  const includesVirtualTour = data.components.some(
    (component: any) => component.type === 'VirtualTour'
  );

  return (
    <>
      <PageContent
        headerBgTransparentOnStart={false}
        contentPaddingTop={'lg'}
        includePrefooterBanner={true}
        isBlockedByLogin={isPreview || data.config.status === 'draft'}
        {
          ...data?.config?.prefooter?.title && { prefooter: { title: data.config.prefooter.title } }
        }
        {...(structuredData && { structuredData })}
      >
        <DynamicPageComponents components={data.components} />
      </PageContent>
      {includesVirtualTour && (
        <ModalVirtualTour
          tourUrl={
            data.components.find(
              (component: any) => component.type === 'VirtualTour'
            ).props.tourUrl
          }
        />
      )}
    </>
  );
};
